<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Language</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Language ISO</label>
          <input class="form-control" [(ngModel)]="languageIso" placeholder="fr_FR" type="text">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
